import { createSlice } from '@reduxjs/toolkit';

interface ConfigState {
  baseURL: string;
}

const initialState: ConfigState = {
  baseURL: import.meta.env.VITE_BASE_URL || 'http://localhost:3000',
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setBaseURL: (state, action) => {
      state.baseURL = action.payload;
    }
  }
});

export const { setBaseURL } = configSlice.actions;
export default configSlice.reducer;
